module.exports = __webpack_public_path__ + "static/puppy-training-ff1ebc5e8968ed788eaf041629f6437b.jpg";